export default __webpack_public_path__ + "static/media/tag-right.29da5f1b.svg";